import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@cotyorg/ccx-atoms/Picture';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import Link from '@cotyorg/ccx-atoms/Link';
import { Newsletter } from '@cotyorg/ccx-molecules/Newsletter';
import R from 'ramda';

export const PartnershipSection = ({
  link,
  images,
  sectionHeading,
  newsletter,
  showNewsletter,
}) => (
  <div className="partnership article-section article-section--padding-top">
    <div className="grid-container">
      <div className="cell text--center">
        <Link className="link" link={R.prop('href', link)} target="_blank">
          <Picture
            alt={R.path([0, 'alt'], images)}
            src={R.path([0, 'imageSrc'], images)}
            srcset={R.path([0, 'imageSrcSet'], images)}
          />
        </Link>
        <Paragraph alignment="center">
          {R.prop('subheading', sectionHeading)}
        </Paragraph>
      </div>
    </div>
    <div className="partnership--background article-section--padding-vertical">
      <div className="grid-container text--white">
        <Paragraph>{R.prop('introduction', sectionHeading)}</Paragraph>
      </div>
    </div>

    {showNewsletter && (
      <div className="grid-container article-section--padding-vertical">
        <Paragraph alignment="center">{newsletter}</Paragraph>
        <div className="grid-container">
          <div className="grid-x grid-margin-x">
            <div className="newsletter-custom cell small-8 medium-4">
              <Newsletter
                buttonType="icon"
                buttonIconSrc="/ccx-files/assets/chevron-right.svg"
              />
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
);

PartnershipSection.propTypes = {
  link: PropTypes.instanceOf(PropTypes.object),
  images: PropTypes.instanceOf(PropTypes.array),
  sectionHeading: PropTypes.instanceOf(PropTypes.object),
  newsletter: PropTypes.string,
  showNewsletter: PropTypes.bool.isRequired,
};
